import React, { useContext, useState } from "react";
import CustomTable from "../../components/CustomTable";
import SubscriptionAdd from "./SubscriptionAdd";
import useApi from "../../hooks/useApi";
import { ListSubscription, updateSubscription } from "../../constants/API/API";
import useFilter from "../../hooks/useFilter";
import SubscriptionUpdate from "./SubscriptionUpdate";
import usePermissions from "../../hooks/usePermissions";
import { permissionKeys } from "../../constants/staffRole";
import { AppStateContext } from "../../context/AppContext";
import { StatusChangeSubscription, } from "../../constants/API/API";
import { message, Space, Button, InputNumber } from "antd";
import moment from "moment";
import { Switch } from "antd";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import SubscriptionView from "./SubscriptionView";
import DeleteRecord from "../../components/DeleteRecord";

const Subscription = () => {
  const { isDelete, isEdit, isView } = usePermissions({
    key: permissionKeys.Employees,
    redirectPermissions: ["isView"],
  });

  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Subscription Management");
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [data, setData] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [totalDocs, setTotalDocs] = useState(0);
  const [filters, setFilters] = useFilter({
    sortField: "createdAt",
    sort: "desc",
    startDate: null,
    endDate: null,
    priceMin: undefined,
    priceMax: undefined,
    durationMin: undefined,
    durationMax: undefined,
  });

  const addSubscription = () => {
    setAddModal(true);
  };

  const handleStatusChange = async (checked, subscription) => {
    setLoading(true);
    try {
      await StatusChangeSubscription(subscription._id, { isActive: checked });
      message.success(
        `Subscription ${checked ? "activated" : "deactivated"} successfully`
      );
      setRefresh(new Date().getTime());
    } catch (error) {
      message.error("Failed to update status");
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setSelectedSubscription(record);
    setEditModal(true);
  };

  const handlePriceMinChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      priceMin: value,
      page: 1,
    }));
  };

  const handlePriceMaxChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      priceMax: value,
      page: 1,
    }));
  };

  const handleView = (record) => {
    setSelectedSubscription(record);
    setViewModal(true);
  };

  useApi({
    callback: ListSubscription,
    payload: filters,
    dependencies: [refresh, filters],
    shouldCallApi: true,
    onSuccess: ({ list, totalDocs }) => {
      setData(list);
      setTotalDocs(totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, item) => (
        <>
          <p>{item?.name}</p>
        </>
      ),
    },
    {
      title: "Price (CAD)",
      dataIndex: "price",
      key: "price",
      render: (price) => `${price || 0}`,
    },
    {
      title: "Validity (Duration)",
      dataIndex: "validity",
      key: "validity",
      render: (_, item) => (
        <>
          <p>{item?.validity}</p>
        </>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => moment(text).format("ll"),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text, record) => (
        <Switch
          checked={record.isActive}
          onChange={(checked) => handleStatusChange(checked, record)}
          disabled={!isEdit}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          {isView && (
            <Button
              type="primary"
              onClick={() => handleView(record)}
              icon={<EyeOutlined />}
              title="View"
            />
          )}
          {isEdit && (
            <Button
              type="primary"
              onClick={() => handleEdit(record)}
              icon={<EditOutlined />}
              title="Edit"
            />
          )}
          {isDelete && (
            <DeleteRecord
              _id={record._id}
              callback={() =>
                updateSubscription({ isDeleted: true }, record._id)
              }
              setLoading={setLoading}
              setRefresh={setRefresh}
              trigger={true}
              type="Subscription"
            />
          )}
        </Space>
      ),
    },
  ];

  const renderFilters = () => {
    return (
      <>
        <div className="main-new-range-inputss">
          <span>Price:</span>
          <InputNumber
            placeholder="Min"
            min={0}
            value={filters.priceMin}
            onChange={handlePriceMinChange}
          />
          <InputNumber
            placeholder="Max"
            min={0}
            value={filters.priceMax}
            onChange={handlePriceMaxChange}
          />
        </div>
        {/* <div className="main-new-range-inputss">
          <span>Duration (Months):</span>
          <InputNumber
            placeholder="Min"
            min={1}
            value={filters.validityMin}
            onChange={handleDurationMinChange}
          />
          <InputNumber
            placeholder="Max"
            min={1}
            value={filters.validityMax}
            onChange={handleDurationMaxChange}
          />
        </div> */}
      </>
    );
  };

  return (
    <>
      <CustomTable
        addFn={addSubscription}
        data={data}
        loading={loading}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        totalDocs={totalDocs}
        searchField={["name"]}
        searchPlaceholder="Search by Subscription Name"
        customFilter={renderFilters}
      />
      {viewModal && (
        <SubscriptionView
          visible={viewModal}
          setVisible={setViewModal}
          id={selectedSubscription}
        />
      )}
      <SubscriptionAdd
        visible={addModal}
        setVisible={setAddModal}
        refresh={setRefresh}
      />
      <SubscriptionUpdate
        editVisible={editModal}
        setEditVisible={setEditModal}
        selectedSubscription={selectedSubscription}
        refresh={setRefresh}
      />
    </>
  );
};

export default Subscription;
